import _ from "lodash";
import FieldNames from "../defaults/FieldNames.json";
import ErrorService from "../services/ErrorService";
import FeatureService from "../services/FeatureService";
import PlannedActualsService from "../services/PlannedActualsService";
import { createFeatureObject } from "./FeatureHelper";
import store from "../redux/store";

export async function getAttachedFeaturesUpdate(tempFeatures, setAllSelectedFeatures, setIsLoading) {

  try
  {
    const allEstimatesWithActuals = tempFeatures?.filter(x => 
          (x[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || x[FieldNames.featureFields.class] === FieldNames.classTypes.activity)
          && x[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes);
    const allActuals = tempFeatures?.filter(x => x[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment || x[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity);

    const polygonEstimatesWithActualsIds = allEstimatesWithActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.polygon).map(x => x[FieldNames.featureFields.id]);
    const lineEstimatesWithActualsIds = allEstimatesWithActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.line).map(x => x[FieldNames.featureFields.id]);
    const pointEstimatesWithActualsIds = allEstimatesWithActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.point).map(x => x[FieldNames.featureFields.id]);
    const polygonActualsIds = allActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.polygon).map(x => x[FieldNames.featureFields.id]);
    const lineActualsIds = allActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.line).map(x => x[FieldNames.featureFields.id]);
    const pointActualsIds = allActuals?.filter(x => x[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.point).map(x => x[FieldNames.featureFields.id]);

    const isEstimate = true;
    const polygonEstResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.polygon, polygonEstimatesWithActualsIds, isEstimate);
    const lineEstResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.line, lineEstimatesWithActualsIds, isEstimate);
    const pointEstResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.point, pointEstimatesWithActualsIds, isEstimate);
    const polygonActualResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.polygon, polygonActualsIds, !isEstimate);
    const lineActualResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.line, lineActualsIds, !isEstimate);
    const pointActualResp = PlannedActualsService.getAttachedFeatures(FieldNames.joinFeatureValues.point, pointActualsIds, !isEstimate);
    let respValues = await Promise.all([polygonEstResp, lineEstResp, pointEstResp, polygonActualResp, lineActualResp, pointActualResp]);
    let combinedResp = [...(respValues?.[0] ?? []), ...(respValues?.[1] ?? []), ...(respValues?.[2] ?? []),
                        ...(respValues?.[3] ?? []), ...(respValues?.[4] ?? []), ...(respValues?.[5] ?? [])];
    let finalCombinedList = [];
    let finalOptions = [];
    if(combinedResp && combinedResp.length > 0){
    combinedResp.forEach(item => {
    const seq = tempFeatures && tempFeatures.length > 0 ? tempFeatures.length + 1 : 1;
    let obj = createFeatureObject(item, seq);
    finalOptions.push(obj);
    })
    }
    finalCombinedList = [...tempFeatures, ...finalOptions];

    setAllSelectedFeatures(finalCombinedList);
    setIsLoading(false);
  }
  catch(error)
  {
    ErrorService.addErrorLogEntry(error);
  }
}

export function getFeatureGroupItemsOrganized(groupItems, setFeatureGroupItems, rootServiceUrl, config, nifcToken) {
  if(groupItems && groupItems.length > 0){
    createFeatureGroupItems(groupItems, setFeatureGroupItems, rootServiceUrl, config, nifcToken);
  }
}

async function createFeatureGroupItems(groupItems, setFeatureGroupItems, rootServiceUrl, config, nifcToken) {
  try
  {
    //We only need to call this once now - Since everything is in the same table
    if(groupItems.length > 0){
      let polygonGroupItems = groupItems.filter(x => x[FieldNames.treatmentActivityGroupItems.joinFeature] === FieldNames.joinFeatureValues.polygon);
      let lineGroupItems = groupItems.filter(x => x[FieldNames.treatmentActivityGroupItems.joinFeature] === FieldNames.joinFeatureValues.line);
      let pointGroupItems = groupItems.filter(x => x[FieldNames.treatmentActivityGroupItems.joinFeature] === FieldNames.joinFeatureValues.point);
      const polygonResp =  FeatureService.getFeaturesByJoinValues(polygonGroupItems.map(x => x[FieldNames.treatmentActivityGroupItems.joinID]), FieldNames.joinFeatureValues.polygon);
      const lineResp =  FeatureService.getFeaturesByJoinValues(lineGroupItems.map(x => x[FieldNames.treatmentActivityGroupItems.joinID]), FieldNames.joinFeatureValues.line);
      const pointResp =  FeatureService.getFeaturesByJoinValues(pointGroupItems.map(x => x[FieldNames.treatmentActivityGroupItems.joinID]), FieldNames.joinFeatureValues.point);
      let respValues = await Promise.all([polygonResp, lineResp, pointResp]);
      let combinedResp = [...(respValues?.[0] ?? []), ...(respValues?.[1] ?? []), ...(respValues?.[2] ?? [])];

      let newItems = [];
      groupItems.forEach((groupItem) => {
        const groupItemJoinId = Number(groupItem[FieldNames.treatmentActivityGroupItems.joinID]);
        const groupItemJoinFeature = groupItem[FieldNames.treatmentActivityGroupItems.joinFeature];
        const feature = combinedResp.filter(x => x[FieldNames.featureFields.joinID] === groupItemJoinId 
                                          && x[FieldNames.featureFields.joinFeature] === groupItemJoinFeature)?.[0];
        if(feature){
          let isTreatment = (feature[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || feature[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
          let isActual = (feature[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity || feature[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
          let entityTypeVal;
          if(isTreatment){
            if(isActual){
              entityTypeVal = FieldNames.entityTypes.actualTreatment;
            } else {
              entityTypeVal = FieldNames.entityTypes.treatment;
            }
          } else {
            if(isActual){
              entityTypeVal = FieldNames.entityTypes.actualActivity;
            } else {
              entityTypeVal = FieldNames.entityTypes.activity;
            }
          }
          const obj = _.cloneDeep(groupItem);
          obj[FieldNames.treatmentActivityGroupItems.entityID] = feature[FieldNames.featureFields.objectID];
          obj[FieldNames.treatmentActivityGroupItems.id] = feature[FieldNames.featureFields.id];
          obj[FieldNames.treatmentActivityGroupItems.entityType] = entityTypeVal;
          obj[FieldNames.featureFields.name] = feature[FieldNames.featureFields.name];
          obj[FieldNames.featureFields.hasActual] = feature[FieldNames.featureFields.hasActual];
          newItems.push(obj);
        }
      });
      setFeatureGroupItems(newItems);
    }
  }
  catch(error)
  {
    ErrorService.addErrorLogEntry(error);
  }
}